import { useTranslation } from '@crew/modules/i18n'
import { useModal } from 'components/layouts/modal/useModal'
import { FC, memo, useCallback } from 'react'
import MaterialSymbolsCrown from '~icons/material-symbols/crown'
import { CrewNavigateToPaidPlanDialog } from '../crewNavigateToPaidPlanDialog/crewNavigateToPaidPlanDialog'

type CrewOnlyForPaidPlanIconProps = {
  width?: number
  height?: number
}

const DEFAULT_ICON_WIDTH = 24
const DEFAULT_ICON_HEIGHT = 24

// 有償プラン限定を示すアイコン
export const CrewOnlyForPaidPlanIcon: FC<CrewOnlyForPaidPlanIconProps> = memo(
  (props) => {
    const { t } = useTranslation()

    // 有償プランへの誘導ダイアログ
    const [
      isNavigateToPaidPlanDialogOpen,
      openNavigateToPaidPlanDialog,
      closeNavigateToPaidPlanDialog,
    ] = useModal()

    // アイコンクリック時の処理
    const handleIconClick = useCallback(
      (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        openNavigateToPaidPlanDialog()
      },
      [openNavigateToPaidPlanDialog]
    )

    // propsで指定がなければデフォルトサイズを使用する
    const width = props.width ?? DEFAULT_ICON_WIDTH
    const height = props.height ?? DEFAULT_ICON_HEIGHT

    return (
      <>
        <div
          className="flex cursor-pointer"
          title={t('label.onlyForPaidPlan')}
          onClick={handleIconClick}
        >
          <MaterialSymbolsCrown
            className="text-crew-yellow-3-light dark:text-crew-yellow-3-dark"
            width={width}
            height={height}
          />
        </div>

        {/* 有償プランへの誘導ダイアログ */}
        <CrewNavigateToPaidPlanDialog
          isOpen={isNavigateToPaidPlanDialogOpen}
          onClose={closeNavigateToPaidPlanDialog}
        />
      </>
    )
  }
)
